export default {
    classNames: {
        displayLinkAnchor: "alme--window--conversation--response--alme__message__displayLinks__link_anchor",
        almeResponsePersonaIconClassName: "alme--window--conversation--response--alme__personaicon_disabled",
        alightResponsePersonaIconClassName: "alme--window--conversation--response--alme__personaicon",
        launchPointDisabled: "alme--launchPointContainer--launchPoint--disabled",
        launchPointHype: "alme--launchPointContainer--launchPoint--hype",
        launchPoint: "alme--launchPointContainer--launchPoint",
        launchPointIcon: "fa-solid fa-comment-lines",
        launchPointIconTemp: "alme--launchPointContainer--launchPoint--temp_icon",
        launchPointMissedNotifications: "alme--launchPointContainer--launchPoint--missed_livechat",
        launchPointBadge:"alme--launchPointContainer--launchPoint--badge",
        launchPointIconAvatar:"alme--launchPointContainer--launchPoint--icon--avatar",
        launchPointIconBackground:"alme--launchPointContainer--launchPoint--icon--background",
        launchPointIconBackgroundHype:"alme--launchPointContainer--launchPoint--icon--background--hype",
        //moreLinkIconClass: "fa-solid fa-chevron-down",
        lessLinkIconClass: "",
        // live chat styles
        livechat: {
            messageReceivedText: "alme--livechat--conversation--message-received__text",
            chatBannerConnectContainer: 'alme--livechat--banner--connect--container',
            chatBannerConnectPrimary: 'alme--livechat--banner--connect--primary',
            chatBannerConnectSecondary: 'alme--livechat--banner--connect--secondary',
            chatBannerConnectAdditional: 'alme--livechat--banner--connect--additional',
            chatBannerDisconnectContainer: 'alme--livechat--banner--disconnect--container',
            chatBannerDisconnectPrimary: 'alme--livechat--banner--disconnect--primary',
            chatBannerDisconnectSecondary: 'alme--livechat--banner--disconnect--secondary',
            chatBannerDisconnectAdditional: 'alme--livechat--banner--disconnect--additional',
            endChatLink: 'alme--livechat--endchat',
            endChatLinkContainer: 'alme--livechat--endchatcontainer',
            headerBannerText: 'alme--livechat--window--header--banner',
            inputContainer: 'alme--livechat--conversation--input',
            inputDisplayName: 'alme--livechat--conversation--input--message__displayname',
            inputMessage: 'alme--livechat--conversation--input--message',
            inputPersonaIcon: 'alme--livechat--conversation--input--personaicon',
            inputText: 'alme--livechat--conversation--input--message__text',
            responseContainer: 'alme--livechat--conversation--response',
            responseDisplayName: 'alme--livechat--conversation--response--message__displayname',
            responseError: 'alme--livechat--response--error',
            responseInlineLink: "alme--livechat--conversation--response--message__link",
            responseMessage: 'alme--livechat--conversation--response--message',
            responsePersonaIcon: 'alme--livechat--conversation--response--personaicon',
            responseText: 'alme--livechat--conversation--response--message__text',
            typingNotification: 'alme--livechat--typingnotification',
        },
        displayLinksSection: "alme--window--conversation--response--alme__message__displayLinks__section",
        displayLinksSectionHeader: "alme--window--conversation--response--alme__message__displayLinks__sectionHeader",

        // overlay form styles
        dataCollectionFeedbackPane: "alme--window--feedback__data-collection",
        dataCollectionValidateRequiredDesc: "alme--window--feedback__data-collection__required-description",
        dataCollectionPaneComboLabel: "alme--window--feedback__data-collection__combo-box-label",
        
        almeResponseErrorClassName: 'alme--response--error',
        almeResponseMessageClassName: 'alme--window--conversation--response--alme__message',
        conversationAreaClassName: 'alme--window--conversation',
        displayLink: 'alme--window--conversation--response--alme__message__displayLinks__link',
        navigationLink: 'alme--window--conversation--response--alme__message__navigationlink',
        windowClassName: 'alme--window',
    },
};


// WEBPACK FOOTER //
// ./settings/class-names.ts